module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 335
 ** module chunks = 1
 **/